import { InjectionToken } from '@angular/core';
import { CacheScenario } from 'app/models/api/cache';
import { incidentsServiceCache } from 'app/services/incidents-service.cache';
import { filtersServiceCache } from 'app/services/filters-service.cache';
import { machinesServiceCache } from 'app/services/machines-service.cache';
import { userFieldsServiceCache } from 'app/services/user-fields-service.cache';
import { legendServiceCache } from 'app/services/legend-service.cache';
import { sparePartsServiceCache } from 'app/services/spare-parts.service.cache';
import { exportServiceCache } from '../services/export-service.cache';

export const SCENARIOS: InjectionToken<CacheScenario[]> = new InjectionToken<CacheScenario[]>(
  'cache scenarios for api interceptor',
  {
    factory: () => [
      ...exportServiceCache(),
      ...machinesServiceCache(),
      ...filtersServiceCache(),
      ...incidentsServiceCache(),
      ...userFieldsServiceCache(),
      ...legendServiceCache(),
      ...sparePartsServiceCache()
    ],
  },
);
